import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { HelpersService } from 'src/app/shared/services/helpers.service';

@Component({
  selector: 'app-redirect-avvisi',
  templateUrl: './redirect-avvisi.component.html',
  styleUrls: ['./redirect-avvisi.component.scss']
})
export class RedirectAvvisiComponent implements OnInit {

  constructor(public helpersService: HelpersService, private activatedRoute: ActivatedRoute) { }

  public titlePage: string = '';

  ngOnInit(): void {
    this.helpersService.nodeType = "pagina";
    this.getParamsFromUrl();
  }
  
  private getParamsFromUrl(): void {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.titlePage = params['title'];
    });
  }
}
